// removed by extract-text-webpack-plugin
module.exports = {"form":"_3NFa7Vg","inputField":"_1-qCna3","email":"_36VsZA_","button":"sETKB_r","privacy":"_2eH56Ze","privacyLink":"_2ssRBgB","message":"_3J045WQ","thankYou":"_36H4P4E","createdIcon":"_1g2J0DO","createdSvg":"_3m24XTa","createdMessage":"REK1XVl"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SavePanel/components/JobMailNew/JobMail.less
 ** module id = 882
 ** module chunks = 0
 **/